import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

interface SideNavSubmenuProps extends HTMLAttributes<HTMLUListElement> {}

export const SideNavSubmenu: FC<SideNavSubmenuProps> = ({ className, ...props }) => {
    return <ul className={classNames('side-nav-submenu', className)} {...props} />;
};
